import * as actionTypes from 'constants/ActionTypes';

const userLimitations = (state = {
    isLoaded: false,
    items: [],
}, action) => {
    switch (action.type) {
        case actionTypes.GET_USER_LIMITATIONS_LIST.REQUEST:
            return {
                ...state,
                isLoaded: false,
            };
        case actionTypes.GET_USER_LIMITATIONS_LIST.SUCCESS:
            return {
                items: action.data,
                isLoaded: true,
            };
        case actionTypes.GET_USER_LIMITATIONS_LIST.FAILURE:
            return {
                ...state,
                isLoaded: true,
            };
        default:
            return state;
    }
};

export default userLimitations;



// WEBPACK FOOTER //
// ./app/reducers/usersLimitations.js